import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../../../../contexts/AuthContext';
import { apiRequest } from '../../../../../common/apiUtils';
import { useDataContext } from '../../../../../contexts/DataContext';

export default function useItemNameSearch(sandboxId, itemName) {
  const { getAccessTokenSilently } = useAuth();
  const { dataContext } = useDataContext();
  const schemaObjects = dataContext.schemaObjects;

  return useQuery({
    queryKey: ['lootByItemName', sandboxId, itemName],
    queryFn: async () => {
      if (!sandboxId || !itemName || !schemaObjects) {
        return null;
      }

      const token = await getAccessTokenSilently();
      const lootSchema = schemaObjects['Loot'];
      if (!lootSchema?.fetchAllEndpoint) {
        throw new Error('Loot schema not found');
      }

      const endpoint = lootSchema.fetchAllEndpoint;
      const replacements = { sandbox_id: sandboxId };
      const extraOptions = {
        queryParams: {
          item_name: itemName,
          expand: 'all',
          page_size: '50',
        },
      };

      const response = await apiRequest(token, endpoint, replacements, null, {}, extraOptions);
      return response.data || [];
    },
    enabled: !!(sandboxId && itemName && schemaObjects && Object.keys(schemaObjects).length > 0),
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
}
